import { FC, ReactNode } from "react";
import styles from "./TextBadge.module.scss";

export type BadgeVariant = "light" | "dark";
export type BadgeSize = "small" | "medium" | "large";
export type BadgePosition = "bottomLeft" | "inline";

interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  size?: BadgeSize;
  position?: BadgePosition;
  className?: string;
}

export const Badge: FC<BadgeProps> = ({
  children,
  variant = "light",
  size = "medium",
  position = "inline",
  className = "",
}) => {
  const classes = [
    styles.badge,
    styles[variant],
    styles[size],
    position === "bottomLeft" && styles.absolute,
    position === "bottomLeft" && styles.bottomLeft,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={classes}>{children}</div>;
};
